var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "create-space-modal",
        classes: "t-modal--sleek",
        adaptive: "",
        height: "auto",
        width: _vm.$isMobile ? "100%" : "480px",
        "pivot-y": _vm.$isMobile ? 1 : 0.5
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c(
        "div",
        { staticClass: "t-pad--t-st t-pad--b-st t-pad--l-st t-pad--r-st" },
        [
          _c("div", [
            _c("div", { staticClass: "t-fw--bold t-fs--h5 t-tc--primary" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.isEdit
                      ? _vm.$t("nav.space.edit_title")
                      : _vm.$t("nav.space.create_title")
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "t-mar--t-mi" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("nav.space.subtitle")) + "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("t-input", {
            staticClass: "t-mar--t-ti",
            attrs: {
              name: "space_name",
              size: "xsmall",
              required: "",
              autofocus: "",
              focus: true,
              fluid: true,
              "max-length": 30,
              label: _vm.$t("nav.space.title_label"),
              placeholder: _vm.$t("nav.space.title_placeholder"),
              "invalid-message": _vm.invalidMsg
            },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.save()
              },
              blur: _vm.blur
            },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          }),
          _vm._v(" "),
          _c("t-textarea", {
            staticClass: "t-mar--t-sm t-fw--normal",
            attrs: {
              name: "space_description",
              size: "small",
              rows: 3,
              "max-length": 80,
              "auto-resize": true,
              label: _vm.$t("nav.space.description_label"),
              placeholder: _vm.$t("nav.space.description_placeholder")
            },
            model: {
              value: _vm.description,
              callback: function($$v) {
                _vm.description = $$v
              },
              expression: "description"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "t-mar--t-st t-flex" },
            [
              _c(
                "t-button",
                {
                  staticClass: "t-mar--r-mi",
                  attrs: { size: "small", fluid: "" },
                  on: {
                    click: function($event) {
                      return _vm.$modal.hide("create-space-modal")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("generic.button.cancel")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "t-button",
                {
                  attrs: {
                    variant: "primary",
                    size: "small",
                    fluid: "",
                    disabled: !_vm.name.trim(),
                    loading: _vm.createLoader
                  },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.isEdit
                          ? _vm.$t("nav.space.save")
                          : _vm.$t("nav.space.create")
                      )
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }